<template>
  <div class="col-12">
    <h2 class="text-center" style="font-size: 1.5rem; font-weight: 700; color: #000000; margin-bottom: 0rem">
      Historia Clínica
    </h2>

    <!-- Loading -->
    <div v-if="cargando_datos" class="text-center p-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #00346b"></i>
      <p>Cargando...</p>
    </div>

    <div v-else class="p-fluid formgrid grid">

      <!-- A) DATOS PERSONALES -->
      <div class="field col-12 md:col-12">
        <span class="texto-span-2"><strong>A) ANAMNESIS - DATOS PERSONALES:</strong></span>
      </div>

      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Lugar de Nacimiento:</span>
          <Textarea v-model="data_historia.lugar_nacimiento" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Escuela:</span>
          <Textarea v-model="data_historia.escuela" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Nivel que cursa:</span>
          <Textarea v-model="data_historia.nivel_que_cursa" rows="1" autoResize />
        </div>
      </div>

      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Nombre de la Madre:</span>
          <Textarea v-model="data_historia.nombre_madre" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Ocupación:</span>
          <Textarea v-model="data_historia.ocupacion_madre" rows="1" autoResize />
        </div>
      </div>

      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Nombre del Padre:</span>
          <Textarea v-model="data_historia.nombre_padre" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Ocupación:</span>
          <Textarea v-model="data_historia.ocupacion_padre" rows="1" autoResize />
        </div>
      </div>

      <!-- B) MOTIVO DE CONSULTA -->
      <div class="field col-12 md:col-12">
        <span class="texto-span-2"><strong>B) MOTIVO DE CONSULTA:</strong></span>
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Motivo:</span>
          <Textarea v-model="data_historia.motivo_consulta" rows="1" autoResize />
        </div>
      </div>

      <!-- C) ANTECEDENTES -->
      <div class="field col-12 md:col-12">
        <span class="texto-span-2"><strong>C) ANTECEDENTES:</strong></span>
      </div>

      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Parto:</span>
          <Textarea v-model="data_historia.parto" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Lactancia Materna:</span>
          <Textarea v-model="data_historia.lactancia_materna" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Uso de Biberón a partir de:</span>
          <Textarea v-model="data_historia.uso_biberon" rows="1" autoResize />
        </div>
      </div>

      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Malos Hábitos:</span>
          <Textarea v-model="data_historia.malos_habitos" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Uso de Chupón:</span>
          <Textarea v-model="data_historia.uso_chupon" rows="1" autoResize />
        </div>
      </div>

      <!-- D) ANTECEDENTES PATOLOGICOS -->
      <div class="field col-12 md:col-12">
        <span class="texto-span-2"><strong>D) ANTECEDENTES PATOLÓGICOS:</strong></span>
      </div>

      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Familiares:</span>
          <Textarea v-model="data_historia.ant_familiares" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Personales:</span>
          <Textarea v-model="data_historia.ant_personales" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Alergias:</span>
          <Textarea v-model="data_historia.alergias" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Toma algún medicamento:</span>
          <Textarea v-model="data_historia.toma_medicamento" rows="1" autoResize />
        </div>
      </div>

      <!-- E) ESTADO BUCODENTAL -->
      <div class="field col-12 md:col-12">
        <span class="texto-span-2"><strong>E) ESTADO BUCODENTAL:</strong></span>
      </div>

      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Estado:</span>
          <Textarea v-model="data_historia.bucodental_estado" rows="1" autoResize placeholder="Buena / Deficiente" />
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Última visita al odontólogo:</span>
          <Textarea v-model="data_historia.ultima_visita_odontologo" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-5">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Trat. Recibido:</span>
          <Textarea v-model="data_historia.trat_recibido" rows="1" autoResize />
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Cuántas veces se cepilla:</span>
          <Textarea v-model="data_historia.frec_cepillado" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Utiliza Hilo Dental:</span>
          <Textarea v-model="data_historia.uso_hilo_dental" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Tipo de Dentición:</span>
          <Textarea v-model="data_historia.tipo_denticion" rows="1" autoResize />
        </div>
      </div>

      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Relación Molar Der.:</span>
          <Textarea v-model="data_historia.relacion_molar_der" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Relación Molar Izq.:</span>
          <Textarea v-model="data_historia.relacion_molar_izq" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Guía Canina Der.:</span>
          <Textarea v-model="data_historia.guia_canina_der" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-3">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Guía Canina Izq.:</span>
          <Textarea v-model="data_historia.guia_canina_izq" rows="1" autoResize />
        </div>
      </div>

      <!-- F) FIRMA -->
      <div class="field col-12 md:col-12">
        <span class="texto-span-2"><strong>F) FIRMA:</strong></span>
      </div>

      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">Parentesco:</span>
          <Textarea v-model="data_historia.firma_parentesco" rows="1" autoResize />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <div class="p-inputgroup flex align-items-center">
          <span class="texto-span">C.I.:</span>
          <Textarea v-model="data_historia.ci_firmante" rows="1" autoResize />
        </div>
      </div>

      <!-- Firma digital -->
      <div class="field col-12 md:col-12">
        <span class="texto-span" style="display: block; margin-bottom: 4px">Firma Digital:</span>
        <div v-if="firma_guardada">
          <img :src="firma_guardada" alt="Firma" height="100" style="border: 0.5px solid #002236; border-radius: 2px" />
        </div>
        <div v-else>
          <div class="canvas-wrapper">
            <canvas ref="canvas" class="canvas-firma"></canvas>
          </div>
        </div>
      </div>

    </div>

    <!-- Botones -->
    <div class="p-inputgroup flex justify-content-end mt-3">
      <Button
        label="IMPRIMIR"
        icon="pi pi-print"
        class="p-button-lg p-button-warning mr-2"
        :disabled="!data_historia.id"
        :loading="imprimiendo"
        @click="imprimir"
      />
      <Button
        v-if="!firma_guardada"
        label="L. FIRMA"
        icon="pi pi-refresh"
        class="p-button-lg p-button-secondary mr-2"
        @click="limpiarFirma"
      />
      <Button
        :label="data_historia.id ? 'ACTUALIZAR' : 'GUARDAR'"
        :icon="data_historia.id ? 'pi pi-refresh' : 'pi pi-save'"
        class="p-button-lg p-button-info"
        @click="guardar"
        :loading="cargando"
      />
    </div>
  </div>
</template>

<script>
import PlanTratamientoService from "@/service/PlanTratamientoService";
import SignaturePad from "signature_pad";

export default {
  emits: ["actualizarListado"],
  props: {
    cliente_id: {
      type: Number,
      default: 0,
    },
  },
  planTratamientoService: null,
  created() {
    this.planTratamientoService = new PlanTratamientoService();
  },
  data() {
    return {
      data_historia: {},
      data_cliente_id: this.cliente_id,
      cargando: false,
      cargando_datos: false,
      imprimiendo: false,
      signaturePad: null,
      firma_guardada: null,
    };
  },
  mounted() {
    if (this.cliente_id) {
      this.cargarDatos();
    }
  },
  methods: {
    cargarDatos() {
      this.cargando_datos = true;
      this.planTratamientoService
        .getHistoriaClinicaKid({ cliente_id: this.data_cliente_id })
        .then((response) => {
          this.data_historia = response.data || {};
          this.firma_guardada = response.data?.firma || null;
          this.cargando_datos = false;
          if (!this.firma_guardada) {
            this.$nextTick(() => this.inicializarFirma());
          }
        });
    },
    inicializarFirma() {
      this.$nextTick(() => {
        const canvas = this.$refs.canvas;
        if (canvas) {
          canvas.width = canvas.offsetWidth || 350;
          canvas.height = 120;
          this.signaturePad = new SignaturePad(canvas);
        }
      });
    },
    limpiarFirma() {
      if (this.signaturePad) this.signaturePad.clear();
      else this.inicializarFirma();
    },
    guardar() {
      this.cargando = true;
      let firma = this.firma_guardada || null;
      if (this.signaturePad && !this.signaturePad.isEmpty()) {
        firma = this.signaturePad.toDataURL("image/png");
      }
      let datos = {
        ...this.data_historia,
        cliente_id: this.data_cliente_id,
        firma: firma,
      };
      this.planTratamientoService.guardarHistoriaClinicaKid(datos).then((response) => {
        if (response.success) {
          this.$toast.add({ severity: "success", summary: "Éxito", detail: response.message, life: 3000 });
          if (firma) this.firma_guardada = firma;
          // Recargar datos para obtener el id y tener todo actualizado
          this.cargarDatos();
          this.$emit("actualizarListado");
        } else {
          this.$toast.add({ severity: "error", summary: "Error", detail: response.message || "Error al guardar", life: 3000 });
        }
        this.cargando = false;
      });
    },
    imprimir() {
      this.imprimiendo = true;
      this.planTratamientoService
        .imprimirHistoriaClinicaKid({ cliente_id: this.data_cliente_id })
        .then(() => { this.imprimiendo = false; });
    },
  },
  watch: {
    cliente_id(val) {
      this.data_cliente_id = val;
      this.data_historia = {};
      this.firma_guardada = null;
      this.signaturePad = null;
      if (val) this.cargarDatos();
    },
  },
};
</script>

<style lang="scss" scoped>
.p-invalid { color: red; }
.texto-span {
  color: #000000;
  font-weight: bold;
  white-space: nowrap;
}
.texto-span-2 {
  color: #00346b;
  font-weight: bold;
  font-size: 1.2rem;
}
.p-inputtextarea {
  border: none;
  border-bottom: 1px dotted #00346b;
  border-radius: 0;
}
.canvas-wrapper {
  width: 100%;
  max-width: 400px;
}
.canvas-firma {
  border: 0.5px solid #002236;
  border-radius: 2px;
  width: 100% !important;
  height: 120px;
  display: block;
}
</style>